var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"source-code"},[_c('pre',{directives:[{name:"hljs",rawName:"v-hljs"}]},[_c('code',{class:_vm.language},[_vm._v(_vm._s(_vm.code))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }